"use strict";

angular.module("contartemx.inicio.poliza.ver_poliza", [
    "contartemx",
    "ngTable",
    "ui.router",
    "ui.bootstrap",
    "datePicker",
    "tableTools",
    "loader"
])

    .controller("PolizaVerCtrl", function PolizasController($scope, $stateParams, $state, $filter, callToWebService, mostrarNotificacion, $uibModal, dateTools, apiCall) {

        $scope.toNew = function () {
            $state.transitionTo('inicio.poliza.nueva');
        };

        $scope.pageError = false;
        $scope.ClavePoliza = $stateParams.num_pol;

        $scope.$watch("ClavePoliza", function (newValue, oldValue) {
            $scope.loading = true;
            callToWebService.postCall('ObtenerPantallaVerPoliza', { clavePoliza: newValue },
                function sucess(data) {
                    $scope.Info = data.Respuesta;
                    $scope.TotalCargos = 0;
                    $scope.TotalAbonos = 0;
                    $scope.historial = $scope.Info.Mensajes;
                    for (var i in $scope.Info.Conceptos) {
                        if ($scope.Info.Conceptos[i].EsCargo) {
                            $scope.TotalCargos += $scope.Info.Conceptos[i].Monto;
                        }
                        else {
                            $scope.TotalAbonos += $scope.Info.Conceptos[i].Monto;
                        }
                    }
                    $scope.loading = false;
                },
                function error(data) {
                    $scope.loading = false;
                    $scope.pageError = true;
                    mostrarNotificacion.error('Ocurrio un error al intentar cargar los datos');

                });
        }, true);

        $scope.abrirArchivo = function () {
            var modalInstance = $uibModal.open({
                template: require('../../../../../app/views/Inicio/Poliza/Poliza_modal.html'),
                controller: MostrarArchivosCtrl,
                windowClass: 'modal--big',
                resolve: {
                    NombreArchivo: function () {
                        return $scope.Info.NombreArchivo;

                    },
                    TipoDeArchivo: function () {
                        return $scope.Info.TipoDeArchivo;
                    }
                }

            });
        };

        var MostrarArchivosCtrl = function ($scope, NombreArchivo, TipoDeArchivo, $uibModalInstance, $http, $state) {
            $scope.NombreArchivo = NombreArchivo;
            $scope.TipoDeArchivo = TipoDeArchivo;
            $scope.loadxml = 0;
            $scope.$watch('loadxml', function () {
                if ($scope.TipoDeArchivo == 1) {
                    LoadXML('XMLHolder', $scope.NombreArchivo);
                }
            });

            $scope.closeModal = function () {
                $uibModalInstance.dismiss();
            };
        };

        $scope.crearComentario = () => {

            let texto = $scope.commentBoxText, cveTransaccion = $stateParams.num_pol;

            if (cveTransaccion && angular.isString(texto) && texto.length) {
                $scope.loading = true;
                apiCall.post('ComentarTransaccion', {
                    comentario: {
                        Texto: texto,
                        CveTransaccion: cveTransaccion
                    }
                })
                    .then(data => {
                        if (data && data.CodigoRespuesta) {
                            if (data.CodigoRespuesta != 500) {
                                window.location.reload();
                            } else {
                                mostrarNotificacion.error(data.Mensaje);
                            }
                        } else {
                            mostrarNotificacion.error('No se pudo publicar el comentario');
                        }
                    }, errror => {
                        mostrarNotificacion.error('No se pudo publicar el comentario');
                    })
                    .finally(() => $scope.loading = false);
            }
        };

});
